import { render, staticRenderFns } from "./CitizenDetailsUpdate.vue?vue&type=template&id=eeae977c&scoped=true&"
import script from "./CitizenDetailsUpdate.vue?vue&type=script&lang=js&"
export * from "./CitizenDetailsUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CitizenDetailsUpdate.vue?vue&type=style&index=0&id=eeae977c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeae977c",
  null
  
)

export default component.exports